import {Injectable} from '@angular/core';
import {HttpRequestService} from "../_common/http-request.service";

@Injectable()
export class SendSignalService {

    constructor(private http: HttpRequestService) {
    }

    getEventSendSignal(parameters) {
        return this.http.get('send-signal-list', parameters)
            .map(res => {
                return res.json();
            })
    }

    setSendSignalActive(model: any) {
        return this.http.post('send-signal/active', model).map(res => {
            return res.json();
        });
    }

    getConstantSendSignal() {
        return this.http.get('send-signal/constants').map(res => {
            return res.json();
        });
    }

    getCoinList(model: any) {
        return this.http.post('send-signal/coin-list', model).map(res => {
            return res.json();
        });
    }

    postListCoinActive(parameter: any) {
        return this.http.post('send-signal/list-coin', parameter).map(res => {
            return res.json();
        });
    }

    postCreateOrUpdateSignalEvent(parameter: any) {
        return this.http.post('send-signal/schedule-event', parameter).map(res => {
            return res.json();
        });
    }

    getListCoinForCMC(parameter: any) {
        return this.http.get('send-signal/list-coin-cmc', parameter).map(res => {
            return res.json();
        });
    }

    postUpdateCoinNameCMC(parameter: any) {
        return this.http.post('send-signal/coin-cmc', parameter).map(res => {
            return res.json();
        });
    }

    getFunctionNameForUser(parameter: any) {
        return this.http.get('send-signal/manage/function-coin-user', parameter).map(res => {
            return res.json();
        });
    }

    setSendSignalFunctionActive(model: any) {
        return this.http.post('send-signal/active-function', model).map(res => {
            return res.json();
        });
    }

    postListCoinNameActive(model: any) {
        return this.http.post('send-signal/show-function-coin', model).map(res => {
            return res.json();
        });
    }

    postCreateOrUpdateEventForUser(parameter: any) {
        return this.http.post('send-signal/event-function/send-for-user', parameter).map(res => {
            return res.json();
        });
    }

    getAllFunctionForUser(parameter?: any) {
        return this.http.get('send-signal/list-function-for-user', parameter).map(res => {
            return res.json();
        });
    }

    postFunctionForUser(parameter?: any) {
        return this.http.post('send-signal/function-for-user', parameter).map(res => {
            return res.json();
        });
    }

    postFunctionByUser(parameter?: any) {
        return this.http.post('send-signal/function-by-user', parameter).map(res => {
            return res.json();
        });
    }

    postFunctionUpdateOrCreateByUser(parameter?: any) {
        return this.http.post('send-signal/setting-function-by-user', parameter).map(res => {
            return res.json();
        });
    }
}


// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_services/send-signal.service.ts